module.exports = __webpack_public_path__ + "img/icon_dialog_svip_level3.adb39e5a.png";